<template>
  <v-container id="uploadCenteri" fluid>
      <v-form>
        <input type="file" id="uploadCenterinput" name="files" style="position: absolute;left:-310px;top:-200px">
      </v-form>
      <v-col cols="12" md="12" v-if="progress !==100" class="pa-4">
        <v-progress-linear
            color="light-blue"
            height="10"
            :value="progress"
            striped
        ></v-progress-linear>
      </v-col>
      <v-col cols="12" xs="2">
        <v-checkbox outlined v-model="isPreviewModel" class="mx-2" label="Preview d.h. es werden zunächst keine Daten erstellt."></v-checkbox>
      </v-col>
        <v-col cols="12" v-if="previewData" class="pa-4">
          <v-data-table
              :headers="headers"
              :items="previewData"
              :items-per-page="-1"
          >
          </v-data-table>
        </v-col>
        <v-col v-else>
          no preview data
        </v-col>
        <v-col xs="12" align="right">
          <v-spacer></v-spacer>
          <v-btn @click.stop="startUpload" primary outlined>Add *.csv</v-btn>
        </v-col>
      <DialogDefault ref="dlgDefault"></DialogDefault>
    </v-container>
</template>

<script>
import Vue from "vue";
import DialogDefault from "@/components/module/dialogs/DialogDefault.vue";

export default {
  name: 'TabImport',
  components: {DialogDefault},
  props: {
    companyId: String,
    companyOwnerID: String
  },
  methods: {
    reload: function () {
      this.isPreviewModel = true;
      this.uploadConfig.uploadUrl = Vue.prototype.$config.HOST + '/v1/companies/upload/' + this.companyId
      this.uploadConfig.onUploadProgress = this.onUploadProgress
      this.uploadConfig.onUploadSuccess = this.onUploadSuccess
      this.initDD()
    },
    initDD: function () {
      console.log('initDD',this.uploadConfig.jQueryDivName, window.jQuery(this.uploadConfig.jQueryDivName))
      if (window.jQuery(this.uploadConfig.jQueryDivName).length === 0 && !window.jQuery(this.uploadConfig.jQueryDivName)) {
        window.setTimeout(this.initDD, 1000)
      } else {
        this.initDragAndDrop(this.uploadConfig, Vue.prototype.$eventHub)
      }
    },
    onC: function() {
      console.log(this.isPreviewModel)
    },
    onUploadProgress: function (id, percent) {
      console.log(id, percent)
      this.progress = percent
    },
    onUploadSuccess (id,data) {
      console.log('upload done', id,data)
      this.previewData = data
      // this.$refs.table.reload(this.guid)
    },
    startUpload: function () {
      console.log('startUpload')
      this.previewData = null
      window.jQuery(this.uploadConfig.jQueryDivName).find('#uploadCenterinput').click()
    },
    getUploadUrl: function(config) {
      if (this.isPreviewModel) {
        return config.uploadUrl + '?isPreview=true'
      } else {
        return config.uploadUrl
      }

    },
    initDragAndDrop(config, eventHub) {
      console.log('init drag and drop', config, window.jQuery(config.jQueryDivName))
      config.eventHub = eventHub
      config.uploadErrorMessage = ''
      this.ddConfig = config
      const cmp = this
      window.jQuery(config.jQueryDivName).dmUploader({
        url: function () {
          return cmp.getUploadUrl(config)
        },
        fileName: 'files',
        dataType: 'json',
        headers: {},
        allowedTypes: '*',
        maxFileSize: 100 * 1024 * 1024,
        // extFilter: 'xlsx',
        onInit: function () {
          console.log('onInit uploader')
        },
        onBeforeUpload: function (id) {
          // updateFileStatus(id, 'uploading', 'Uploading...')
          console.log(id)
          config.eventHub.$emit('lockScreen')
        },
        onNewFile: function (id, file) {
          config.eventHub.$emit('unlockScreen')
          console.log(id, file)
        },
        onComplete: function () {
          console.log('upload complete')
          config.eventHub.$emit('unlockScreen')
        },
        onUploadProgress: function (id, percent) {
          if (config.onUploadProgress) config.onUploadProgress(id, percent)
        },
        onUploadSuccess: function (id, data) {
          if (config.onUploadSuccess) config.onUploadSuccess(id, data)
          cmp.$eventHub.$emit('unlockScreen')
        },
        onUploadError: function (id, message) {
          cmp.$eventHub.$emit('unlockScreen')
          cmp.$refs.dlgDefault.open({
            title: 'Upload Fehler',
            description: config.uploadErrorMessage + '(' + message + ')'
          })
        },
        onFileTypeError: function (file) {
          console.log('onFileTypeError', file)
          cmp.$eventHub.$emit('unlockScreen')
          config.uploadErrorMessage = 'Dateitype nicht erlaubt.  Erlaubt sind (csv)'
          cmp.$refs.dlgDefault.open({
            title: 'Upload Fehler',
            description: config.uploadErrorMessage
          })
        },
        onFileSizeError: function (file) {
          console.log('onFileSizeError', file)
          cmp.$eventHub.$emit('unlockScreen')
          config.uploadErrorMessage = 'Ihre Datei ist zu gross. Erlaubt sind maximal 100 Megabyte.'
          cmp.$refs.dlgDefault.open({
            title: 'Upload Fehler',
            description: config.uploadErrorMessage
          })
        },
        onFileExtError: function (file) {
          console.log('onFileExtError', file)
          cmp.$eventHub.$emit('unlockScreen')
          config.uploadErrorMessage = 'Dateitype nicht erlaubt.  Erlaubt sind (xlsx)'
          cmp.$refs.dlgDefault.open({
            title: 'Upload Fehler',
            description: config.uploadErrorMessage
          })
        },
        onFallbackMode: function (message) {
          cmp.$refs.dlgDefault.open({
            title: 'Upload Fehler',
            description: message + config.uploadErrorMessage
          })
        }
      })
    }
  },
  data () {
    return {
      progress: 100,
      isPreviewModel: true,
      previewData: null,
      headers: [
        { text: 'Standort', value: 'Standort' },
        { text: 'Büroadresse Straße', value: 'Büroadresse Straße' },
        { text: 'PLZ', value: 'PLZ' },
        { text: 'Ort', value: 'Ort' },
        { text: 'Ansprechpartner', value: 'Ansprechpartner' },
        { text: 'Telefonnummer', value: 'Telefonnummer' },
        { text: 'Büro E-Mailadresse', value: 'Büro E-Mailadresse' },
        { text: 'Bosys Company ID', value: 'Bosys Company ID' }
      ],
      uploadConfig: {
        uploadUrl: '',
        jQueryDivName: '#uploadCenteri'
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
